import { ref } from 'vue'
import { useSlidingChatGlobal } from '@/modules/chat-matrix-fast/composables/useSlidingChatGlobal'
import { resolveActiveMessageRoomId } from '@/modules/chat-matrix-fast/utils/topics'
import type { IChat, IChatTopic } from '@/modules/chat-matrix-fast/types/IChat'

/** Сколько fullscreen/embedded поверхностей чата сейчас смонтировано. */
const mountedChatSurfaces = ref(0)

/** Messenger page / EmbeddedChat: комната считается «открытой» только пока UI чата на экране. */
export function retainChatSurface(): void {
  mountedChatSurfaces.value += 1
}

export function releaseChatSurface(): void {
  mountedChatSurfaces.value = Math.max(0, mountedChatSurfaces.value - 1)
}

/** Открыт ли UI чата (страница, sliding drawer или embedded). */
export function isChatSurfaceActive(): boolean {
  if (mountedChatSurfaces.value > 0) {
    return true
  }

  return useSlidingChatGlobal().isSlidingChatVisible.value
}

function isDocumentVisible(): boolean {
  return typeof document === 'undefined' || document.visibilityState === 'visible'
}

/** UI чата смонтирован и вкладка на экране — пользователь реально смотрит. */
export function isChatBeingViewed(): boolean {
  return isChatSurfaceActive() && isDocumentVisible()
}

type ActiveRoomState = {
  activeTopic: IChatTopic | null
  currentChat: IChat | null
  showTopicsList?: boolean
}

/** Room id только если пользователь реально смотрит чат; иначе stale currentChat не глушит toast/unread. */
export function resolveViewedMessageRoomId(state: ActiveRoomState): string | undefined {
  if (!isChatBeingViewed()) {
    return undefined
  }

  return resolveActiveMessageRoomId(state)
}
